import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'bom-expandable-list-item',
  templateUrl: './expandable-list-item.component.html',
  styleUrls: ['./expandable-list-item.component.scss'],
})
export class ExpandableListItemComponent {
  @Input()
  title: string;

  @Input()
  shortText: string;

  @Input()
  longText: string;

  @Input()
  isLoading: boolean;

  @Input()
  isDisabled: boolean;

  @Input()
  isHighlighted: boolean;

  @Input()
  canBeDeleted: boolean;

  @Input()
  isDeleteDisabled: boolean;

  @Input()
  isExpanded: boolean;

  @Input()
  isBeingDeleted: boolean;

  @Input()
  type: 'item' | 'subitem' = 'item';

  @Input()
  hide: boolean;

  @Output()
  delete = new EventEmitter<void>();

  @Output()
  toggleExpand = new EventEmitter<void>();

  deleteClick() {
    this.delete.emit();
  }

  toggleExpandClick() {
    if (!this.isLoading) {
      this.toggleExpand.emit();
    }
  }
}
